import { ref } from "vue";
import { useSessionStorage } from "vue-composable";

const { storage: only_100_percent_green } = useSessionStorage('only_100_percent_green', {
  selected: false,
  disabled: false
});
const { storage: only_time_of_use } = useSessionStorage('only_time_of_use', { selected: false, disabled: false });
const { storage: only_no_deposit } = useSessionStorage('only_no_deposit', { selected: false, disabled: false });
const { storage: include_auto_pay } = useSessionStorage('include_auto_pay', { selected: true, disabled: false });

const clear = () => {
  only_100_percent_green.value = {
    selected: false,
    disabled: false
  }
  only_time_of_use.value = {
    selected: false,
    disabled: false
  }
  only_no_deposit.value = {
    selected: false,
    disabled: false
  }
  include_auto_pay.value = {
    selected: false,
    disabled: false
  }
}

export default () => {
  return {
    only_100_percent_green,
    only_time_of_use,
    only_no_deposit,
    include_auto_pay,
    clear
  }
}
